import React from 'react';
import { Grid } from '@mui/material';

import { ContainerColumnLeft, InfoField } from '@occc-app/design-system';
import { getWalletSteeringValue } from '@occc-app/routes/Wallet/utils';
import { Unit_Of_Measure } from '@occc/graphql';

import { CardLayout } from '@occc/ui-design-system';
import { titleByDimension, titleByOperator } from './constants';

import { WalletSteeringAttribute } from '../../types';

interface WalletSteeringItemsProps {
  walletSteeringItems: WalletSteeringAttribute[];
}

export const WalletSteeringItems: React.FC<WalletSteeringItemsProps> = ({
  walletSteeringItems,
}) => {
  return (
    <ContainerColumnLeft>
      <CardLayout title='Wallet Steering'>
        {walletSteeringItems.map(({ wallet, walletSteeringOperator, value, attribute }, index) => {
          const unitOfMeasure = wallet?.configuration.unitOfMeasure ?? Unit_Of_Measure.Unit;

          return (
            <Grid container spacing={3} key={index}>
              <Grid item xs={12} sm={6} md={3}>
                <InfoField label='Wallet' value={wallet?.name} sx={{ wordBreak: 'break-all' }} />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <InfoField label='Dimension' value={titleByDimension[attribute]} />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <InfoField label='Compare By' value={titleByOperator[walletSteeringOperator]} />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <InfoField label='Value' value={getWalletSteeringValue(value, unitOfMeasure)} />
              </Grid>
            </Grid>
          );
        })}
      </CardLayout>
    </ContainerColumnLeft>
  );
};
